import { chargebeeOptin } from '@/api/services/chargebee';
import { Text } from '@/components/Text';
import { TextLink } from '@/components/TextLink';
import { navigate } from '@/navigations/RootNavigation';
import { useDialog } from '@/hooks/useDialog';
import { useStoreActions, useStoreState } from '@/stores/store';
import { logError } from '@/utils/logHandling';
import { Links } from '@/config/links';
import { IS_WEB } from '@/utils/platform';
import { openURL } from 'expo-linking';
import theme from '@/config/theme';

export const useChargebeeConsentNavigation = () => {
  const signedInUser = useStoreState((state) => state.signedInUser);
  const setUserData = useStoreActions((actions) => actions.setUserData);
  const { removeDialog, showDialog } = useDialog();

  const handleNavigation = () => {
    IS_WEB ? navigate('LicenseBooking') : openURL(Links.license.href);
  };

  const triggerNavigationOrConsent = () => {
    if (signedInUser.user?.digaUser === true) {
      removeDialog();
      showDialog({
        title: 'Einwilligung zur Datenverarbeitung',
        contentComponent: () => (
          <Text
            style={{ fontSize: theme.fontSizes.lg, padding: theme.spacings.md }}
          >
            Ich willige ein, dass zur Zahlungsabwicklung meine Daten durch die
            externen Dienstleister Stripe (Stripe Payments Europe, Ltd., 1 Grand
            Canal Street Lower, Grand Canal Dock, Dublin, Irland) und Chargebee
            (909 Rose Avenue, Suite 610, North Bethesda, MD 20852, USA)
            verarbeitet werden. Diese externen Dienstleister sind zur
            gesetzmäßigen, vertraulichen und sicheren Behandlung Ihrer Daten
            verpflichtet und dürfen Ihre Daten nur verwenden, soweit dies zur
            Erfüllung ihrer Aufgabe erforderlich ist. Weitere Infos finden Sie
            in unserer{' '}
            <TextLink href={Links.datenschutz.href}>
              Datenschutzerklärung
            </TextLink>
            . Ich kann diese Einwilligung jederzeit widerrufen.
          </Text>
        ),
        confirmAction: {
          label: 'Einwilligen',
          onPress: async () => {
            await chargebeeOptin()
              .then((response) => {
                if (response.data.message.includes('successful')) {
                  setUserData({
                    ...signedInUser,
                    user: { ...signedInUser.user, digaUser: false },
                  });
                  handleNavigation();
                  removeDialog();
                }
              })
              .catch((e) => {
                logError(e);
              });
          },
        },
        cancelAction: {
          label: 'Abbrechen',
          onPress: removeDialog,
        },
      });
    } else {
      handleNavigation();
      removeDialog();
    }
  };

  return { triggerNavigationOrConsent };
};
